import { Text, Box, Dialog, Button } from '@machobear/design-system'

import { useTranslation } from 'react-i18next'

import Warning from './warning.svg?react'

const ExitConfirmationModal = ({
  visible,
  closeModal,
  handleModalConfirm
}: {
  visible: boolean
  closeModal: () => void
  handleModalConfirm: () => void
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      width="xsmall"
      id="form-exit-modal"
      open={visible}
      onClose={closeModal}
      title={t('b.components.edit.exit_warning_title', 'Are you sure you want to exit?')}
      illustration={
        <Box paddingTop="large" paddingBottom="none">
          <Warning />
        </Box>
      }
      description={
        <Text tone="secondary" weight="medium" align="center">
          {t(
            'b.components.edit.exit_warning_description',
            'You have unsaved changes. If you exit now, these changes will be lost.'
          )}
        </Text>
      }
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        gap="small"
      >
        <Button variant="transparent" onClick={closeModal}>
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button variant="solid" onClick={handleModalConfirm}>
          {t('b.components.edit.exit_warning_yes', 'Yes, exit')}
        </Button>
      </Box>
    </Dialog>
  )
}

export default ExitConfirmationModal
